<template lang="pug">
.form-digital-seo
    .form-digital-seo__grid
        .form-digital-seo__label
            | Title

        .form-digital-seo__field
            SvTextarea(
                v-model="seo_title"
                placeholder="Минимальная длина 45 символов, максимальная 80"
                :rows="2"
            )

        .form-digital-seo__label
            | Description

        .form-digital-seo__field
            SvTextarea(
                v-model="seo_description"
                placeholder="Минимальная длина 100 символов, максимальная длина 150"
                :rows="3"
            )

        .form-digital-seo__label
            | Keywords

        .form-digital-seo__field
            SvTextarea(
                v-model="seo_keywords"
                placeholder="Не больше 25 слов, максимальная длина не ограничена"
                :rows="4"
            )
</template>

<script>
import SvTextarea from '@/components/uikit/SvTextarea.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'FormDigitalSeo',

  components: {
    SvTextarea,
  },

  computed: {
    ...mapGetters({
      current: 'digital/getCurrent',
    }),

    seo_title: {
      get() { return this.current.seo_title; },
      set(seo_title) { this.setValue({ seo_title }); },
    },

    seo_description: {
      get() { return this.current.seo_description; },
      set(seo_description) { this.setValue({ seo_description }); },
    },

    seo_keywords: {
      get() { return this.current.seo_keywords; },
      set(seo_keywords) { this.setValue({ seo_keywords }); },
    },
  },

  methods: {
    ...mapMutations({
      setValue: 'digital/setValue',
    }),
  },
};
</script>


<style lang="scss" scoped>
.form-digital-seo {
    min-height: calc(100vh - 263px);

    &__grid {
        display: grid;
        grid-template-columns: 240px 790px;
        grid-column-gap: 50px;
        grid-row-gap: 25px;
        margin-top: 50px;
    }

    &__label {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
        font-size: 14px;
        color: #404450;
        font-weight: 500;
    }
}
</style>
